import m from 'm';

import menu from 'pages/menu';
import reactCreator from 'components/react.creator';

import { getLanguagesAvailableWithCode } from 'services/language/languageService';

const component = {};

component.view = function view() {
  const languages = getLanguagesAvailableWithCode();

  return m('.page', { style: { height: '100%' } }, [
    m('.header', [m(menu)]),
    m(reactCreator, {
      component: 'ContentList',
      props: {
        languages,
      },
      style: {
        height: '100%',
      },
    })
  ]);
};

export default component;
